import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Trendingtabdetails from './Trendingtabdetails';
import { Button, Container, Grid } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import { Link } from 'react-router-dom';
import Trendingtop from './Trendingtop';



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs() {
    const [value, setValue] = React.useState(0);
    const [currency ,setCurrency]=React.useState('BNB');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

  
    return (
        <Box className='Trending_inn' paddingY={5}>
            <Container maxWidth='xl'>
                <Grid container spacing={2}>
                    <Grid item lg={8} sm={12} md={6} xs={12}>
                        <Box className='completing'>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                <Tab label="Trending" {...a11yProps(0)} />
                                <Tab label="Top" {...a11yProps(1)} />
                            </Tabs>
                        </Box>
                    </Grid>
                    <Grid item lg={2} sm={12} md={6} xs={12}>
                        <Box className='Partners_in'>
                            <FormControl fullWidth>
                                <InputLabel variant="standard" htmlFor="uncontrolled-native"> </InputLabel>
                                <NativeSelect defaultValue="BNB" onChange={(e)=>{setCurrency(e.target.value)}}>
                                    <option value="BNB">BNB</option>
                                    <option value="MATIC">MATIC</option>
                                </NativeSelect>
                            </FormControl>
                        </Box>
                    </Grid>
                    <Grid item lg={2} sm={12} md={6} xs={12}>
                        <Box className='new_pg'>
                        <Link to={'Rankingdetails'}>
                                <Button variant='contained'>View All</Button>
                            </Link>
                        </Box>
                    </Grid>

                    <Grid item lg={12} sm={12} md={6} xs={12}>
                        <TabPanel value={value} index={0} className='supposed'>
                            <Trendingtabdetails currency={currency}/>
                        </TabPanel>
                    </Grid>
                    <Grid item lg={12} sm={12} md={6} xs={12}>
                        <TabPanel value={value} index={1} className='supposed'>
                            <Trendingtop currency={currency} />
                        </TabPanel>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}